import axios from "axios";
import { SERVER_URL } from "../const";
import Qs from 'qs';



export const getDrawbackDetailsService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to the API endpoint using Axios
    const response = await axios.get(`${SERVER_URL}/get-drawback-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};
